import { useEffect, useState } from "react";

import { opzioniSede } from "../certificate/pipeline";
import { getWorkplaces } from "./utils";

/*
 Le sedi di lavoro gia' in uso in azienda, pronte da suggerire in un campo di testo.

 Sono suggerimenti, non un elenco vincolante: la sede di lavoro e' dichiarata sul dipendente e
 non e' legata alle sedi dell'azienda, quindi chi compila deve poterne scrivere una nuova. Il
 loro scopo e' che chi sta scrivendo una sede che esiste gia' la ritrovi scritta come le altre,
 invece di crearne una gemella.

 Le voci passano da `opzioniSede`: le varianti di scrittura collassano in una sola e i vuoti
 non si suggeriscono. La forma proposta e' quella normalizzata — chi normalizza la tendina
 normalizza anche il confronto, altrimenti il suggerimento accettato resterebbe un doppione.

 `attivo` evita la richiesta finche' la scheda non e' aperta, e la rifa' a ogni riapertura:
 cosi' una sede appena inserita compare tra i suggerimenti della volta dopo.
*/
export function useSediDiLavoro(attivo: boolean): string[] {
  const [sedi, setSedi] = useState<string[]>([]);

  useEffect(() => {
    if (!attivo) return;
    let annullato = false;
    getWorkplaces("employee-registry-errore-sedi-suggerite").then((elenco) => {
      if (annullato) return;
      setSedi(
        Object.keys(opzioniSede(elenco, ""))
          .filter((chiave) => chiave !== "")
          .sort((a, b) => a.localeCompare(b)),
      );
    });
    return () => {
      annullato = true;
    };
  }, [attivo]);

  return sedi;
}
